import { FC } from "react";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import { QuestionResponse, QuestionnaireGetResponse } from "capitalrx-types";

import { QuestionsSection } from "./QuestionsSection";
import { useQuestionnaireDetermination } from "@/utils";

interface Props {
  questionnaire: QuestionnaireGetResponse;
  isPreview?: boolean;
  isReadonly?: boolean;
  sortedQuestions: QuestionResponse[];
  debugMode?: boolean;
}

export const QuestionnaireContent: FC<Props> = ({ debugMode, questionnaire, isPreview, isReadonly, sortedQuestions }): JSX.Element => {
  const { id: questionnaireId } = questionnaire;

  const { activeQuestions, questionStatus }
    = useQuestionnaireDetermination({ questionnaire, sortedQuestions });

  return (
    <Stack spacing="large" testId="questionnaire_questions">
      <QuestionsSection
        allQuestions={sortedQuestions}
        questions={activeQuestions}
        questionStatus={questionStatus}
        questionnaireId={questionnaireId}
        isReadonly={isReadonly}
        isPreview={isPreview}
        debugMode={debugMode}
      />
    </Stack>
  );
};
